module.exports = __webpack_public_path__ + "img/0d4437d96d91d53cfc82a2e397e5f3e.05529c43.jpg";